import { LocationType } from '@/shared/types/generated';

/**
 * Maps form string values to GraphQL LocationType enum values
 */
export function mapLocationTypeToEnum(locationType: string): LocationType {
  switch (locationType.toLowerCase()) {
    case 'home':
      return LocationType.Home;
    case 'apartment':
      return LocationType.Apartment;
    case 'other':
      return LocationType.Other;
    default:
      return LocationType.Home;
  }
}

/**
 * Maps GraphQL LocationType enum to form string values (lowercase)
 */
export function mapEnumToLocationType(locationType?: LocationType): string {
  switch (locationType) {
    case LocationType.Home:
      return 'Home';
    case LocationType.Apartment:
      return 'Apartment';
    case LocationType.Other:
      return 'Other';
    default:
      return 'Home';
  }
}
